<script lang="ts">
    import { cn } from "@/lib/utils";
    import {round, type XSSDetails} from "../../Util/utils";
    export let xss: XSSDetails = {xhss: 0, xpss: 0, xlss: 0, xss: 0}
    let className: string = undefined
    export {className as class}

</script>

<div class={cn("grid items-baseline justify-items-center gap-x-3 gap-y-1", className)}>  
    <span class="text-lg font-bold">{Math.round(xss.xss)}</span>
    <span class="text-[--color-xlss]">{Math.round(xss.xlss)}</span>
    <span class="text-[--color-xhss]">{round(xss.xhss, 1)}</span>
    <span class="text-[--color-xpss]">{round(xss.xpss, 1)}</span>
    <span class="row-start-2 text-sm text-slate-500">Total</span>
    <span class="row-start-2 text-sm text-slate-500">Low</span>
    <span class="row-start-2 text-sm text-slate-500">High</span>
    <span class="row-start-2 text-sm text-slate-500">Peak</span>
</div>